import React from 'react'
import Layout from '../../Components/Layout'
import BannerGlobal from '../../Components/BannerGlobal'
import TeamComponent2 from '../../Components/TeamComponent2'
import useDocumentTitle from '../../Hooks/PageTitle'

const TeamPage = () => {
  useDocumentTitle("TRoo Traveling | Team Page")
  return (
    <div>
        <Layout>
            <BannerGlobal/>
            <TeamComponent2/>
        </Layout>
    </div>
  )
}

export default TeamPage